import classNames from 'classnames'
import { Link } from 'react-router-dom'
import Button from 'components/forms/Button'

import styles from './styles/VisualizeButton.css'

const getUrl = ({ paper, userSlug }) => {
  if (paper) {
    return `/visualizations/${encodeURIComponent(paper.slug)}`
  }

  if (userSlug) {
    return `/visualizations/authorprofiles/${userSlug}`
  }

  return ''
}

const AnchorText = ({ text }) => (
  <>
    <i className={styles.icon} />
    <span className={styles.text}>
      {text}
    </span>
  </>
)

export const VisualizeButton = ({ className = '', paper, userSlug, button = true }) => {
  const text = paper ? 'Visualize citations' : 'Visualize author profile'

  return (
    <Link className={classNames(styles.link, className)} to={getUrl({ paper, userSlug })}>
      {
        button
          ? (
            <Button className={styles.button} color='blue'>
              <AnchorText text={text} />
            </Button>
            )
          : <AnchorText text={text} />
      }
    </Link>
  )
}

export default VisualizeButton
